<template>
  <section>
    <div v-if="isAdmin">
      <v-container fluid>
        <v-tabs v-model="tab" background-color="#f8f9fa">
          <v-tab href="#tab-1"> Багшийн мэргэжлийн зэрэг </v-tab>
          <v-tab href="#tab-2"> Менежерийн мэргэжлийн зэрэг </v-tab>
        </v-tabs>
      </v-container>

      <v-tabs-items v-model="tab" style="background-color: #f8f9fa">
        <v-tab-item value="tab-1">
          <v-container fluid>
            <v-card>
              <div class="card-header-padding my-10 mt-10">
                <div>
                  <h5 class="font-weight-bold text-h4 text-typo mb-0">
                    Багшийн мэргэжлийн зэрэг
                  </h5>
                  <class class="d-flex flex-row justify-space-between">
                    <p class="text-typo">
                      Багшийн мэргэжлийн зэргийн xүсэлтийг xүлээн аваx ажлыг энд
                      зоxион байгуулна.
                    </p>
                  </class>

                  <v-progress-linear v-if="loading" indeterminate color="red">
                  </v-progress-linear>
                  <v-data-table
                    v-if="teacherZeregs && teachers"
                    :items="filteredTeacherZeregs"
                    :headers="headerNames"
                    hide-default-footer
                    :items-per-page="-1"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>{{ item.index }}</td>
                        <td>{{ item.DISPLAY_NAME }}</td>
                        <td>{{ item.PERSON_ID }}</td>
                        <td>{{ item.selectedZereg.name }}</td>
                        <td>{{ getZeregLastUpdatedTime(item) }}</td>
                        <td>{{ getZeregSentAtTime(item) }}</td>
                        <td>
                          <v-btn
                            x-small
                            :text="isTeacherApproved(item) == false"
                            :class="
                              isTeacherApproved(item) == true
                                ? 'bg-gradient-success white--text'
                                : isTeacherApproved(item) == null
                                ? 'bg-gradient-danger white--text'
                                : 'red--text'
                            "
                            @click="openTeacherZereg(item)"
                          >
                            <!-- <v-icon class="mr-1" v-if="isTeacherLive(item)"
                              >mdi-eye-outline</v-icon
                            > -->
                            <span>
                              {{
                                isTeacherApproved(item) == true
                                  ? "Баталгаажсан"
                                  : isTeacherApproved(item) == false
                                  ? "Цуцлагдсан"
                                  : "Баталгаажуулах"
                              }}
                            </span>
                          </v-btn>

                          <!-- <span v-else>-</span> -->
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
              </div>
            </v-card>
          </v-container>
        </v-tab-item>
        <v-tab-item value="tab-2">
          <TeacherZeregTable
            :selectedTeacher="userData"
            :isForManager="true"
            v-bind="$attrs"
          ></TeacherZeregTable>
        </v-tab-item>
      </v-tabs-items>

      <v-dialog
        v-model="showTeacherZereg"
        max-width="1300px"
        v-if="renderComponent"
      >
        <v-card style="background-color: white; overflow-y: scroll">
          <TeacherZeregTable
            :selectedZereg="selectedZereg"
            :selectedTeacher="selectedTeacher"
            :isAdmin="isAdmin"
            v-bind="$attrs"
          ></TeacherZeregTable>
        </v-card>
      </v-dialog>
    </div>
    <TeacherZeregTable
      v-else
      :selectedTeacher="selectedTeacher"
      :isForManager="true"
      v-bind="$attrs"
    ></TeacherZeregTable>
  </section>
</template>

<script>
import { mapState } from "vuex";
import { sync } from "vuex-pathify";
import TeacherZeregTable from "./TeacherZeregTable.vue";
import moment from "moment";
export default {
  data() {
    return {
      tab: null,
      isAdmin: false,
      teacherZeregs: null,
      headerNames: [
        { text: "No.", value: "index" },
        { text: "Нэр", value: "DISPLAY_NAME" },
        { text: "Багшийн ID", value: "PERSON_ID" },
        { text: "Зэргийн нэр", value: "" },
        { text: "Сүүлд хадгалсан огноо", value: "" },
        { text: "Илгээсэн огноо", value: "" },
        { text: "Үйлдэл", value: "" },
      ],
      selectedTeacher: null,
      teachers: null,
      loading: false,
      showTeacherZereg: false,
      selectedZereg: null,
      renderComponent: true,
    };
  },

  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
    filteredTeacherZeregs() {
      var list = [];
      var index = 1;
      this.teacherZeregs.forEach((zeregs) => {
        if (zeregs.zereg) {
          zeregs.zereg.forEach((zereg) => {
            if (zereg.finished && zereg.sentAt) {
              var tmpZereg = JSON.parse(JSON.stringify(zeregs));

              var foundTeacher = this.teachers.find(
                (t) => String(t.PERSON_ID) == String(tmpZereg.PERSON_ID)
              );

              if (foundTeacher) {
                tmpZereg.DISPLAY_NAME = foundTeacher.DISPLAY_NAME;
              }
              tmpZereg.index = index;
              index++;

              tmpZereg.selectedZereg = {};
              tmpZereg.selectedZereg.name = zereg.name;
              tmpZereg.selectedZereg.zeregType = zereg.zeregType;
              tmpZereg.selectedZereg.sentAt = zereg.sentAt;

              list.push(tmpZereg);
            }
          });
        }
      });

      list = list.sort(
        (a, b) => a.selectedZereg.sentAt - b.selectedZereg.sendAt
      );

      return list;
    },
  },
  components: {
    TeacherZeregTable,
  },
  methods: {
    async forceRerender() {
      this.renderComponent = false;
      await this.$nextTick();
      this.renderComponent = true;
    },
    openTeacherZereg(item) {
      var foundTeacher = this.teachers.find(
        (t) => String(t.PERSON_ID) == String(item.PERSON_ID)
      );
      if (foundTeacher) {
        foundTeacher.school = this.userData.school;
        this.selectedZereg = item.selectedZereg;
        this.selectedTeacher = foundTeacher;
        this.showTeacherZereg = true;
      }
      this.forceRerender();
    },
    // teacherHasZereg(teacher) {
    //   var foundZereg = this.teacherZeregs.find(
    //     (teacherZereg) =>
    //       String(teacherZereg.PERSON_ID) == String(teacher.PERSON_ID)
    //   );

    //   return foundZereg ? true : false;
    // },
    isTeacherApproved(item) {
      var zeregDoc = this.getTeacherZereg(item);

      var isApproved = null;
      if (zeregDoc) {
        var foundZereg = zeregDoc.zereg.find(
          (z) => z.zeregType == item.selectedZereg.zeregType
        );
        if (foundZereg && foundZereg._stateOfDocument == 2) {
          isApproved = true;
        } else if (foundZereg && foundZereg._stateOfDocument == 3) {
          isApproved = false;
        }
      }
      return isApproved;
    },
    // isTeacherLive(item) {
    //   var zeregDoc = this.getTeacherZereg(item);

    //   var isLive = false;
    //   if (zeregDoc) {
    //     zeregDoc.zereg.forEach((zrg) => {
    //       if (zrg && zrg.lastUpdatedAt) {
    //         const currentTime = new Date().getTime();

    //         const timestampMillis = zrg.lastUpdatedAt.toMillis();

    //         const timeDifference = currentTime - timestampMillis;

    //         const fiveMinutesInMillis = 5 * 60 * 1000;

    //         if (timeDifference <= fiveMinutesInMillis) {
    //           isLive = true;
    //         }
    //       }
    //     });
    //   }
    //   return isLive;
    // },
    getZeregSentAtTime(item) {
      var zeregDoc = this.getTeacherZereg(item);

      if (zeregDoc) {
        var selectedZereg = zeregDoc.zereg.find(
          (z) => z.zeregType == item.selectedZereg.zeregType
        );

        if (selectedZereg && selectedZereg.sentAt) {
          return this.formattedDate(selectedZereg.sentAt);
        }
      }

      return "-";
    },
    getZeregName(item) {
      return item.selectedZereg.name;
    },
    getZeregLastUpdatedTime(item) {
      var zeregDoc = this.getTeacherZereg(item);
      if (zeregDoc) {
        var selectedZereg = zeregDoc.zereg.find(
          (z) => z.zeregType == item.selectedZereg.zeregType
        );

        if (selectedZereg && selectedZereg.lastUpdatedAt) {
          return this.formattedDate(selectedZereg.lastUpdatedAt);
        }
      }
      return "-";
    },
    getTeacherZereg(teacher) {
      var foundZereg = this.teacherZeregs.find(
        (teacherZereg) =>
          String(teacherZereg.PERSON_ID) == String(teacher.PERSON_ID)
      );
      return foundZereg;
    },
    formattedDate(date) {
      return moment(date.toDate()).format("YYYY-M-D HH:mm:ss");
    },
  },
  created() {
    if (this.userData.role != "teacher") {
      this.isAdmin = true;
      this.loading = true;

      this.userData.school.ref
        .collection("teachers")
        .where("role", "==", "teacher")
        .where("deleted", "==", false)
        .orderBy("FIRST_NAME", "asc")
        .get()
        .then((docs) => {
          this.teachers = [];
          var counter = 0;
          docs.forEach((doc) => {
            counter++;
            let teacher = doc.data();
            teacher.id = doc.id;
            teacher.ref = doc.ref;
            teacher.index = counter;
            this.teachers.push(teacher);
          });
          this.loading = false;
        });

      this.userData.school.ref.collection("teacherZereg").onSnapshot((docs) => {
        this.teacherZeregs = [];
        docs.forEach(async (doc) => {
          let teacherZereg = doc.data();
          teacherZereg.id = doc.id;
          teacherZereg.ref = doc.ref;

          this.teacherZeregs.push(teacherZereg);
        });
      });
    }
  },
};
</script>
